<app-header (found)="handleResults($event)"></app-header>
<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '14px' }"></ngx-loading>
<div id="main-wrapper" class="main-background topSpace main-container clinicalContainer claims-summary-details" >
  <div class="container-fluid" style="padding: 0;">
    <app-search-results [resultGridList]="data"></app-search-results>
    <div class="tab homeAccrordian claimSummaryHeading">
      <h1 class="carelon-page-title m-t-20">Claims List</h1>
      <div class="row clinicalContent whiteBg tableShadow claimPage">
        <div class="col-lg-12 padmar0">
          <div class="col-md-12 usersite-column tab-content cup-grid-footer-align message-grid cup-grid-bottom">
            <div class="row">
              <p class="claimId">Claim ID: <span>{{claimId}}</span></p>
              <div class="memberContainer mainClinicalTable claimSummaryTable">
                <div class="memberContainer mainClinicalTable">
                  <table class="table-responsive custom-table myTable clinicalTable stcikyHeaders claimDetail" id="myTable"

                    >
                    <thead>
                      <tr class="table-header stickyHeader">
                        <th width="200">CPT</th>
                        <th width="100">Member ID</th>
                        <th width="90">Member Name</th>
                        <th width="90">DOS</th>
                        <th class="bh" width="90">Billed</th>
                        <th width="60">Copay</th>
                        <th class="pAWidth" width="90">Pay<span class="dblock">Amount</span></th>
                        <th width="85">Status</th>
                        <th class="ccodeWidth">Capitation<span class="dblock">Code</span></th>
                        <th class="cdWidth">Capitation<span class="dblock">Description</span></th>
                        <th class="cnWidth">Check<span class="dblock"></span>Number</th>
                        <th class="cdWidth">Check<span class="dblock">Date</span></th>
                        <th class="patientAccount">Patient Account<span class="dblock">Number</span></th>
                        <th width="80">Line level<span class="dblock">Details</span></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr  *ngFor="let claim of eachClaim | paginate: { itemsPerPage: 10, currentPage: p } as results; index as rowIndex">
                        <td>{{claim.procedure[0].procedureCode + ' ' +  claim.procedure[0].procedureDesc}}</td>
                        <td>{{memberId}}</td>
                        <td>{{memberName}}</td>
                        <td>{{claim.dateOfServiceFrom | customFormat}}</td>
                        <td><span class="dollarSign">{{claim.billed | number : '1.2-2'}}</span></td>
                        <td><span class="dollarSign">{{claim.copay | number : '1.2-2'}}</span></td>
                        <td><span class="dollarSign">{{claim.payAmount | number : '1.2-2'}}</span></td>
                        <td>{{claim.statusDesc}}</td>
                        <td>{{claim.capitationCode}}</td>
                        <td>{{claim.capitationDesc}}</td>
                        <td>{{claim.checkNumber}}</td>
                        <td>{{claim.checkDate | customFormat}}</td>
                        <td>
                          {{patientAccountNumber}}
                        </td>
                        <td class="centerAlign">
                          <i class="fa fa-eye cursorPointer" aria-hidden="true" (click)="showClaimModal(claim);"></i>
                        </td>
                      </tr>
                      <tr class="sumRow">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>Total</td>
                        <td><span class="dollarSign">{{totalBilled | number : '1.2-2'}}</span></td>
                        <td><span class="dollarSign">{{totalCopay |  number : '1.2-2'}}</span></td>
                        <td><span class="dollarSign">{{totalPayAmount |  number : '1.2-2'}}</span></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr align="center" class="paginationTab"><td colspan="14"><pagination-controls (pageChange)="p = $event"></pagination-controls></td></tr>
                    </tbody>
                  </table>
                  <button class="carelon-primary-btn back-btn" (click)="goBack()">Go back</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade claimDetailsModal" id="claimDetailsModalId" role="dialog">
  <div class="modal-dialog" style="margin-top: 15%;">
    <div class="modal-content" style="width: 115%;">
      <div class="modal-header">
        <h4 class="pull-left">Claim Details</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <table class="claimPopupTable">
          <tbody>
            <tr>
              <td>
                <div>
                  <label>CPT CODE</label>
                  <p>{{cptCode}}</p>
                </div>
              </td>
              <td>
                <div>
                  <label>DOS</label>
                  <p>{{dateOfServiceFrom | customFormat}}</p>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div>
                  <label>Withhold</label>
                  <p>{{withhold}}</p>
                </div>
              </td>
              <td>
                <div>
                  <label>Denied</label>
                  <p>{{denied}}</p>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div>
                  <label>Reason</label>
                  <p>{{disallowExDesc}}</p>
                </div>
              </td>
              <td>
                <div>
                  <label>Servicing Provider</label>
                  <p>{{servicingProvider}}</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<app-footer ></app-footer>
